import React from 'react';

import { FINANCING_AMOUNT } from 'modules/Inquiry/Form/formFields';
import { AmountWithField } from 'modules/Inquiry/Form/Steps/FinancingNeed/Amount/Amount';
import { useFieldValidators } from 'shared/hooks/useFieldValidators';
import { useTranslations } from 'utils/hooks/useTranslations';
import { upperBound, combineValidators } from 'utils/validators';

const NeededFinancingForKfw = ({ maxFinancing }: { maxFinancing: number }) => {
  const t = useTranslations('pages.coronaStep.fields.neededFinancing');
  const { required, maxLength, minPrice } = useFieldValidators();

  const validatorAmount = { amount: maxFinancing };
  const maxValueValidator = upperBound(maxFinancing, t('errorOtherKfwProgram', validatorAmount));
  return (
    <AmountWithField
      caption={t('caption')}
      name={FINANCING_AMOUNT}
      validate={combineValidators(required, maxLength(9), minPrice(1000), maxValueValidator)}
    />
  );
};

export default NeededFinancingForKfw;
